import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";

async function fetchUserNotifications() {
    if (typeof isLimitAccess === 'undefined') {
        return;
    }

    if (!this.currentUser || isLimitAccess) {
        return;
    }

    const [err, responseData] = await to(
        api.user.notifications()
    );

    let userNotifications = {};

    if (!err) {
        userNotifications = _.get(responseData, 'data', []);
    }

    if (typeof userNotifications.unread_message_count !== 'undefined') {
        this.store.commit('setConversationUnreadMessageCount', userNotifications.unread_message_count);
    }

    if (typeof userNotifications.new_profile_view_count !== 'undefined') {
        this.store.commit('setUserProfileViewsNotificationCount', userNotifications.new_profile_view_count);
    }
}

function listenWebsocketForNotificationCount() {
    $.getScript({url: regionRelativeUrl('/js/app-sockets.js', true), cache: true}).then(() => {
        this.store.commit('setWebsocketIsReady', true);

        Echo.private((`Notifications.User.${this.currentUser.id}`))
            .listen('.notifications.updated', (data) => {
                if (typeof data.unreadMessageCount !== 'undefined') {
                    this.store.commit('setConversationUnreadMessageCount', data.unreadMessageCount);
                }

                if (typeof data.newProfileViewCount !== 'undefined') {
                    this.store.commit('setUserProfileViewsNotificationCount', data.newProfileViewCount);
                }
            });
    })
}

export default {
    data() {
        return {
            store: $store,
        }
    },
    computed: {
        ...mapState(['currentUser']),
    },
    methods: {
        fetchUserNotifications,
        listenWebsocketForNotificationCount,
    },
}
